/**
 * Global Webhook Configuration
 * 
 * This file provides consistent webhook configuration for all cart-related scripts.
 * Update the values below to match your setup.
 */

window.CART_WEBHOOK_CONFIG = {
  webhookUrl: 'https://shopify.infinitediscs.com/webhook/theme_webhook.php',
  apiKey: 'c0ade8be7fe6165b9fa0d8eb0779efb7bb9eafe9e65914794d70c52bc8c34a6f',
  shop: 'disc-source.myshopify.com',
  enableLogging: true
};

// Also set DAWN_WEBHOOK_CONFIG for backward compatibility with proper structure
window.DAWN_WEBHOOK_CONFIG = {
  webhookUrl: 'https://shopify.infinitediscs.com/webhook/theme_webhook.php',
  apiKey: 'c0ade8be7fe6165b9fa0d8eb0779efb7bb9eafe9e65914794d70c52bc8c34a6f',
  shop: 'disc-source.myshopify.com',
  enabled: true,
  debug: true,
  events: {
    cart: {
      add: true,
      update: true,
      remove: true,
      clear: true,
      note: true
    }
  }
};

console.log('[Webhook Config] Configuration loaded:', {
  shop: window.CART_WEBHOOK_CONFIG.shop,
  hasApiKey: !!window.CART_WEBHOOK_CONFIG.apiKey,
  webhookUrl: window.CART_WEBHOOK_CONFIG.webhookUrl,
  loggingEnabled: window.CART_WEBHOOK_CONFIG.enableLogging,
  dawnConfig: window.DAWN_WEBHOOK_CONFIG
});

